import { useRef, useState } from "react";
import {
  Card,
  CardContent,
  TextField,
  Grid,
  IconButton,
  Typography,
  Box,
  Tooltip,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  List,
  ListItem,
  ListItemText,
  Button,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
// import { useSelector } from "react-redux";
import axios from "axios";
import CloseIcon from "@mui/icons-material/Close";
import AllTransactionTable from "./AllTransactionTable";
import ToastComponent from "../../components/customTable/ToastComponent";
import axiosInstance from "../../utils/axiosInstance";

const FindTotalCommission = ({sliceResponse=[]}) => {
  const baseUrl = import.meta.env.VITE_BASE_URL;
  const token = localStorage.getItem("token");

  // const sliceResponse = useSelector(
  //   (state) => state.parnerReportCommission.parnerReportCommission.data || state.partnerInvoice.partnerInvoice.data
  // );

  // const [selectedOption, setSelectedOption] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [data, setdata] = useState(null);

  const [formErrors, setFormErrors] = useState({});

  const handleSearch = async (e) => {
    e.preventDefault();

    // Validation
    const errors = {};
    if (!selectedId || !inputValue) errors.SelectPartner = "This is required";
    setFormErrors(errors);
    if (Object.keys(errors).length > 0) return;
    try {
      // const url = `${baseUrl}/getSinglePartnerCommission/${selectedOption?._id}?startDate=${startDate}&endDate=${endDate}`;
      const url = `/getSinglePartnerCommission/${selectedId}?startDate=${startDate}&endDate=${endDate}`;
      // const url = `${baseUrl}/getSinglePartnerCommission/${selectedId}?startDate=${startDate}&endDate=${endDate}`;
      const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      };
      const response = await axiosInstance.get(url);
      // const response = await axios.get(url, { headers });
      const data = response?.data?.data;
      if (data) {
        setdata(data);
      }
    } catch (error) {
      console.error("Error fetching partner commission:", error);
    }
  };
  const handleClear = () => {
    setFormErrors({});
    // setSelectedOption(null);
    setStartDate("");
    setEndDate("");
    setdata(null);
    setSelectedId("");
    setInputValue("");
  };

  const [inputValue, setInputValue] = useState(""); // For input field
  const [filteredOptions, setFilteredOptions] = useState([]); // For filtered results
  const [showDropdown, setShowDropdown] = useState(false); // Dropdown visibility
  const [selectedId, setSelectedId] = useState(""); // Tracks selected option's _id

  const inputRef = useRef(null);

  // Handle input changes and filter the dropdown list
  const handleInputChange = (e) => {
    setFormErrors({});

    const value = e.target.value;
    setInputValue(value);

    // Filter options based on input
    // const filtered = options.filter((option) =>
    const filtered = sliceResponse?.filter(
      (option) =>
        option?.name.toLowerCase().includes(value.toLowerCase()) ||
        option?.username.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredOptions(filtered || []);

    setShowDropdown(true);
  };

  // Handle focus to show all options initially
  const handleFocus = () => {
    setFormErrors({});

    // setFilteredOptions(options); // Show all options on focus
    setFilteredOptions(sliceResponse || []); // Show all options on focus
    setShowDropdown(true);
  };

  // Handle selection of an option
  const handleOptionClick = (option) => {
    setInputValue(option?.name); // Set input field to selected name
    setSelectedId(option?._id); // Store the selected _id
    setShowDropdown(false);
  };

  // Close dropdown when clicking outside
  const handleBlur = () => {
    setTimeout(() => setShowDropdown(false), 150); // Delay to allow selection clicks
  };

  const [showAllTransectionTable, setshowAllTransectionTable] = useState(false);

  return (
    <Card sx={{ margin: "auto", p: 1, mb: 3, overflow: "visible" }}>
      <ToastComponent />
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Find Total Commission
        </Typography>

        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={5}>
            <Box sx={{ position: "relative" }}>
              <TextField
                autoComplete="off"
                label="Search Partner"
                size="small"
                inputRef={inputRef}
                value={inputValue}
                // Autocomplete={false}
                onChange={handleInputChange}
                onFocus={handleFocus} // Show all options on focus
                onBlur={handleBlur}
                // placeholder="Search Partner"
                variant="outlined"
                fullWidth
                error={!!formErrors.SelectPartner}
                helperText={formErrors.SelectPartner}
                InputProps={{
                  sx: {
                    // borderRadius: "8px",
                    // "&:hover": { borderColor: "#007bff" },
                  },
                }}
              />

              {/* Dropdown List */}
              {showDropdown && (
                <List
                  sx={{
                    position: "absolute",
                    width: "100%", // Matches TextField width
                    maxHeight: "200px",
                    overflowY: "auto",
                    backgroundColor: "white",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                    zIndex: 1301, // High z-index (MUI default modal z-index is 1300)
                    marginTop: "4px",
                    padding: 0,
                  }}
                >
                  {filteredOptions?.length > 0 ? (
                    filteredOptions?.map((option) => (
                      <ListItem
                        key={option._id}
                        button
                        onMouseDown={() => handleOptionClick(option)}
                        sx={{
                          "&:hover": { backgroundColor: "#f0f0f0" },
                          cursor: "pointer",
                        }}
                      >
                        <ListItemText
                          primary={
                            option?.name ? option?.name : option?.username
                          }
                        />
                        <span style={{ fontSize: 12 }}>{option?.username}</span>
                      </ListItem>
                    ))
                  ) : (
                    <ListItem>
                      <ListItemText
                        primary="No results found"
                        sx={{ color: "#999", fontStyle: "italic" }}
                      />
                    </ListItem>
                  )}
                </List>
              )}
            </Box>
          </Grid>

          {/* <Grid item xs={12} sm={5}>
            <Autocomplete
              size="small"
              options={sliceResponse || []}
              getOptionLabel={(option) =>
                option?.name || option?.username || ""
              }
              filterOptions={(options, state) =>
                options.filter(
                  (option) =>
                    option.name
                      ?.toLowerCase()
                      .includes(state.inputValue.toLowerCase()) ||
                    option.username
                      ?.toLowerCase()
                      .includes(state.inputValue.toLowerCase())
                )
              }
              value={selectedOption}
              onChange={(event, newValue) => {
                setSelectedOption(newValue);
                setFormErrors({});
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Partner"
                  variant="outlined"
                  error={!!formErrors.SelectPartner}
                  helperText={formErrors.SelectPartner}
                />
              )}
              fullWidth
            />
          </Grid> */}

          <Grid item xs={12} sm={3}>
            <TextField
              size="small"
              type="date"
              label="Start Date"
              InputLabelProps={{ shrink: true }}
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              size="small"
              type="date"
              label="End Date"
              InputLabelProps={{ shrink: true }}
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={1}>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Tooltip title="Search">
                <IconButton onClick={handleSearch} color="primary" size="small">
                  <SearchIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Clear">
                <IconButton onClick={handleClear} color="primary" size="small">
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            </Box>
          </Grid>
        </Grid>

        {data && (
          <>
            <TableContainer sx={{ mt: 3 }}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>Partner ID</TableCell>
                    <TableCell>Name</TableCell>
                    <TableCell>Username</TableCell>
                    <TableCell>Total Commission</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow
                    // key={row.name}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell>{data?.partner_id}</TableCell>
                    <TableCell> {data?.name}</TableCell>
                    <TableCell> {data?.username}</TableCell>
                    <TableCell>{data?.totalCommission}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
            <Button
              variant="contained"
              onClick={() => setshowAllTransectionTable((prev) => !prev)}
            >
              {showAllTransectionTable
                ? "Hide All Transactions"
                : "Show All Transactions"}
            </Button>
          </>
        )}

        {showAllTransectionTable && <AllTransactionTable data={data} />}
      </CardContent>
    </Card>
  );
};

export default FindTotalCommission;
